import { Plugin } from 'ckeditor5';
import { ConditionState } from './State';
import { ConditionsSchema } from './schema';
import { ConditionsUI } from './ui';
import './augmentation';
export class ConditionsPlugin extends Plugin {
    static get pluginName() {
        return 'ConditionsPlugin';
    }
    static get requires() {
        return [ConditionState, ConditionsSchema, ConditionsUI];
    }
    /** Supplies the question list's label resolver. See `ConditionsSchema`. */
    setRefResolver(resolver) {
        this.editor.plugins.get(ConditionsSchema).setRefResolver(resolver);
    }
    /** Re-renders every condition pill after the question list changed. See `ConditionsSchema`. */
    refreshLabels() {
        this.editor.plugins.get(ConditionsSchema).refreshLabels();
    }
}
